exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#no-background-hover[data-v-2923a33d]{background-color:transparent!important;border-color:transparent!important}.v-select[data-v-2923a33d]{width:5%}.text-head[data-v-2923a33d]{font-family:Karla;font-style:normal;font-weight:700;font-size:16px;line-height:23px;display:flex;align-items:center;letter-spacing:-.02em;color:#303941}", ""]);

// exports
